<template>
  <div class="translation-engine">
    <el-table
      border
      height="100%"
      ref="multipleTable"
      tooltip-effect="dark"
      :data="translationEngineList"
      header-row-class-name="customHeader"
    >
      <el-table-column :label="$t('newProjectV2.serialNumber')" align="center" width="55">
        <template slot-scope="{ $index }">
          {{$index + 1}}
        </template>
      </el-table-column>
      <el-table-column
        :label="$t('newProjectV2.enable')"
        align="center"
        prop="code"
        width="70"
      >
        <template slot-scope="{ row }">
          <el-radio v-model="lang" @change="radioChange(row.id)" :label="row.code">{{''}}</el-radio>
        </template>
      </el-table-column>
      <el-table-column
        :label="$t('newProjectV2.translationEngineName')"
        align="center"
        show-overflow-tooltip
        class-name="engine-name"
      >
        <!-- :src="require('./assets/images/'+ row.code +'.png')" -->
        <template slot-scope="{ row }"><div :class="`engine-icon icon-${row.code}`"></div>{{row.name}}</template>
      </el-table-column>
      <el-table-column
        :label="$t('newProjectV2.supportLang')"
        align="center"
        show-overflow-tooltip
        class-name="operate"
      >
        <template slot-scope="{ row }">
          <el-tooltip popper-class="support" :content="supportLangFormat(row)" placement="top">
            <span class="check"></span>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
export default {
  name: 'TranslationEngine',
  props: {
    translationEngineList: {
      type: Array,
      default () {
        return []
      }
    },
    translationEngine: {
      type: String,
      default () {
        return 'fanyu'
      }
    }
  },
  data () {
    return {
      lang: this.translationEngine,
    }
  },
  methods: {
    radioChange () {
      this.$emit('translationEngineChange', this.lang);
    },
    supportLangFormat (item) {
      let supportLang = '';
      item.supportLangName.forEach(lang => {
        supportLang += lang + '、';
      });
      return supportLang.substr(0, supportLang.length - 1);
    }
  }
}
</script>

<style lang="less" scoped>
  @import "./assets/style.less";
</style>
<style lang="less">
  .support.el-tooltip__popper {
    max-width: 30% !important;  //宽度可根据自己需要进行设置 
  }
</style>